import { Box } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useTranslation } from "@localization/useTranslation";
import WithinAppetiteIcon from "./withinAppetite.svg?react";
import { useRiskAppetiteStatusPillStyles } from "./RiskAppetiteStatusPill.styles";

interface RiskAppetiteStatusPillProps {
    isExceeded: boolean;
}

// The "appetite exceeded / within appetite" pill. Its own colours carry the status, so it reads the same on the
// report's dark blue card and on the dashboard widget's white box, which is why both share it.
function RiskAppetiteStatusPill({ isExceeded }: RiskAppetiteStatusPillProps) {
    const { translateString } = useTranslation();
    const styles = useRiskAppetiteStatusPillStyles();

    if (isExceeded) {
        return (
            <Box sx={[styles.statusPill, styles.statusPillExceeded]}>
                <ReportProblemOutlinedIcon />
                {translateString("riskManagementReportAppetiteExceeded")}
            </Box>
        );
    }

    return (
        <Box sx={[styles.statusPill, styles.statusPillWithin]}>
            <WithinAppetiteIcon />
            {translateString("riskManagementReportAppetiteWithin")}
        </Box>
    );
}

export default RiskAppetiteStatusPill;
